import { render } from "./EthereumRateFourChart.vue?vue&type=template&id=37480702&ts=true"
import script from "./EthereumRateFourChart.vue?vue&type=script&lang=ts"
export * from "./EthereumRateFourChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__